module.exports = __webpack_public_path__ + "img/抽獎紀錄title.3877fc1b.png";